"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mobx = require("mobx");

var _mobx2 = require("../../util/mobx");

var _FormApiStorageProvider = _interopRequireDefault(require("./storage/FormApiStorageProvider"));

var _BaseStorageProvider = _interopRequireDefault(require("./storage/BaseStorageProvider"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _transform = _interopRequireDefault(require("lodash/transform"));

var _mapValues = _interopRequireDefault(require("lodash/mapValues"));

var _includes = _interopRequireDefault(require("lodash/includes"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _reduce = _interopRequireDefault(require("lodash/reduce"));

var _isNull = _interopRequireDefault(require("lodash/isNull"));

var _filter = _interopRequireDefault(require("lodash/filter"));

var _split = _interopRequireDefault(require("lodash/split"));

var _some = _interopRequireDefault(require("lodash/some"));

var _find = _interopRequireDefault(require("lodash/find"));

var _keys = _interopRequireDefault(require("lodash/keys"));

var _emmett = _interopRequireDefault(require("emmett"));

var _uniqid = _interopRequireDefault(require("uniqid"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var FormModel = (_class = /*#__PURE__*/function () {
  // data should be either scalar values or Arrays of forms (i.e. <key>: <value> | [Form])
  function FormModel(props, storageProvider, _validations) {
    var _this = this;

    _classCallCheck(this, FormModel);

    _initializerDefineProperty(this, "data", _descriptor, this);

    _initializerDefineProperty(this, "_originalData", _descriptor2, this);

    _initializerDefineProperty(this, "_validationComputeds", _descriptor3, this);

    _initializerDefineProperty(this, "_doneFields", _descriptor4, this);

    _initializerDefineProperty(this, "_serverErrors", _descriptor5, this);

    _initializerDefineProperty(this, "_errorFieldsFromServer", _descriptor6, this);

    _defineProperty(this, "_setupComputedValidationErrors", function (validations) {
      var computedValidationErrors = (0, _transform.default)(validations, function (accumulator, validation, fieldName) {
        accumulator[fieldName] = (0, _mobx.computed)(function () {
          return validation.validate(fieldName, _this);
        });
      }); // eslint-disable-next-line lodash/prefer-lodash-method

      _this._validationComputeds.clear();

      _this._validationComputeds.merge(computedValidationErrors);
    });

    if (!(0, _isUndefined.default)(props.data)) {
      this.data = _mobx.observable.map(props.data);
      this.setOriginalData();
    }

    if (!(0, _isUndefined.default)(props.errors)) {
      this._serverErrors = _mobx.observable.map(props.errors);
    }

    this.parent = (0, _isUndefined.default)(props.parent) ? null : props.parent; // set up backing storage

    if ((0, _isUndefined.default)(storageProvider) || (0, _isNull.default)(storageProvider)) {
      if (!(0, _isEmpty.default)(props.endpoint) || !(0, _isEmpty.default)(props.deleteEndpoint)) {
        var onFormErrorCallback = function onFormErrorCallback(errors) {
          if ((0, _isFunction.default)(_this.validationErrorCallback)) {
            _this.validationErrorCallback(errors);
          } // eslint-disable-next-line lodash/prefer-lodash-method


          _this._serverErrors.clear();

          _this._serverErrors.merge(errors);

          _this._processErrorsFromServer();

          _this.onFormError();
        };

        this.storageProvider = new _FormApiStorageProvider.default(props.endpoint, props.deleteEndpoint, onFormErrorCallback.bind(this));
      } else {
        this.storageProvider = new _BaseStorageProvider.default();
      }
    } else {
      this.storageProvider = storageProvider;
    } // set up form emitter


    this.emitter = new _emmett.default();
    this.key = (0, _uniqid.default)();

    this._setupComputedValidationErrors(_validations);
  }

  _createClass(FormModel, [{
    key: "serverErrors",
    get: function get() {
      var _this2 = this;

      var errors = new Map(); // eslint-disable-next-line lodash/prefer-lodash-method

      this._serverErrors.forEach(function (errorMessages, fieldName) {
        var currentValue = _this2.data.get(fieldName);

        var comparedValue = (0, _mobx.toJS)(_this2._errorFieldsFromServer.get(fieldName));
        var clonedCurrentValue = (0, _mobx.toJS)(currentValue);

        if (!(0, _isUndefined.default)(currentValue) && !(0, _isUndefined.default)(comparedValue) // field data has changed since getting an error back from the server
        && !(0, _isEqual.default)(clonedCurrentValue, comparedValue)) {
          return;
        }

        errors.set(fieldName, errorMessages);
      });

      return errors;
    }
  }, {
    key: "errors",
    get: function get() {
      var _this3 = this;

      var errors = new Map(); // eslint-disable-next-line lodash/prefer-lodash-method

      this.serverErrors.forEach(function (errorMessages, fieldName) {
        return errors.set(fieldName, errorMessages);
      }); // eslint-disable-next-line lodash/prefer-lodash-method

      this.computedValidationErrors.forEach(function (computedValidationError, fieldName) {
        if (_this3._doneFields.has(fieldName)) {
          errors.set(fieldName, computedValidationError);
        }
      });
      return errors;
    }
  }, {
    key: "computedValidationErrors",
    get: function get() {
      var errors = _mobx.observable.map(); // eslint-disable-next-line lodash/prefer-lodash-method


      this._validationComputeds.forEach(function (validationComputed, fieldName) {
        var errorMessages = validationComputed.get();

        if ((0, _find.default)(errorMessages, function (errorMessage) {
          return errorMessage;
        })) {
          errors.set(fieldName, errorMessages);
        }
      });

      return errors;
    }
  }, {
    key: "validationSteps",
    get: function get() {
      return {};
    }
  }, {
    key: "setOriginalData",
    value: function setOriginalData() {
      this._originalData = _mobx.observable.map(this.getData());
    }
  }, {
    key: "getData",
    value: function getData() {
      return this._getDataHelper(this.data);
    }
  }, {
    key: "getOriginalData",
    value: function getOriginalData() {
      return this._getDataHelper(this._originalData);
    } // re-implement observable map toJS(), except with sub-form handling for forms with arrays

  }, {
    key: "_getDataHelper",
    value: function _getDataHelper(data) {
      var jsonData = {}; // eslint-disable-next-line lodash/prefer-lodash-method

      data.forEach(function (value, key) {
        var isSubformArray = false;

        if (FormModel._isSubform(value)) {
          jsonData[key] = value.getData();
        } else {
          if (FormModel._isSubformArray(value)) {
            // arrays in forms can be sub-forms
            jsonData[key] = [];
            (0, _forEach.default)(value, function (subform) {
              if ((0, _isFunction.default)(subform.getData)) {
                isSubformArray = true;
                jsonData[key].push(subform.getData());
              }
            });
          }

          if (!isSubformArray) {
            // basic toJS() case
            jsonData[key] = (0, _mobx.toJS)(value);
          }
        }
      });
      return jsonData;
    }
  }, {
    key: "canSubmit",
    get: function get() {
      return Boolean(!this.hasErrors && this.hasChanges);
    }
  }, {
    key: "hasChanges",
    get: function get() {
      var _this4 = this;

      var originalDataKeys = _mobx2.observableMap.keys(this._originalData);

      var currentDataKeysThatAreNew = (0, _filter.default)(_mobx2.observableMap.keys(this.data), function (key) {
        return !(0, _includes.default)(originalDataKeys, key);
      });
      var originalDataChanges = (0, _find.default)(originalDataKeys, function (fieldName) {
        return _this4.hasChanged(_this4._originalData.get(fieldName), _this4.data.get(fieldName), fieldName);
      });
      var currentDataChanges = (0, _find.default)(currentDataKeysThatAreNew, function (fieldName) {
        return _this4.hasChanged(_this4._originalData.get(fieldName), _this4.data.get(fieldName), fieldName);
      });
      return originalDataChanges || currentDataChanges;
    }
  }, {
    key: "hasChanged",
    value: function hasChanged(fieldValue1, fieldValue2, fieldName) {
      var _this5 = this;

      if (fieldValue2 instanceof FormModel) {
        return fieldValue2.hasChanges;
      }

      if ((0, _mobx.isObservableArray)(fieldValue1)) {
        if ((0, _isNull.default)(fieldValue2) || fieldValue1.length !== fieldValue2.length) {
          return true;
        }

        return (0, _some.default)((0, _mobx.toJS)(fieldValue1), function (field, key) {
          return _this5.hasChanged(fieldValue1[key], fieldValue2[key]);
        });
      }

      if (fieldValue1 instanceof Object && fieldValue2 instanceof Object) {
        return (0, _some.default)((0, _keys.default)((0, _mobx.toJS)(fieldValue1)), function (key) {
          return _this5.hasChanged(fieldValue1[key], fieldValue2[key], key);
        });
      }

      if ((0, _isEqual.default)(Number(fieldValue1), 0) && (0, _isEqual.default)(Number(fieldValue2), 0)) {
        return false;
      }

      return fieldValue1 !== fieldValue2;
    }
  }, {
    key: "hasErrors",
    get: function get() {
      return this.errors.size > 0;
    }
  }, {
    key: "allStepErrors",
    get: function get() {
      var _this6 = this;

      return (0, _mapValues.default)(this.validationSteps, function (mapKeys) {
        return _this6.hasErrorsForKeys(mapKeys);
      });
    }
  }, {
    key: "hasErrorsForKeys",
    value: function hasErrorsForKeys(mapKeys) {
      var _this7 = this;

      return (0, _find.default)(mapKeys, function (key) {
        return _this7.errors.has(key);
      });
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return (0, _reduce.default)(_mobx2.observableMap.values(this.data), function (result, value) {
        if (FormModel._isSubform(value)) {
          return value.isEmpty;
        } else if (FormModel._isSubformArray(value)) {
          return result && (0, _reduce.default)(value, function (subResult, subform) {
            return subResult && subform.isEmpty;
          }, true);
        }

        var isFieldEmpty = (0, _isUndefined.default)(value) || (0, _isNull.default)(value) || typeof value === "string" && (0, _isEmpty.default)(value);
        return result && isFieldEmpty;
      }, true);
    }
    /* Warning: Will null-out non-nullable fields on a form */

  }, {
    key: "clear",
    value: function clear(fieldsToPreserve) {
      var _this8 = this;

      var newData = new Map();

      this._doneFields.clear();

      (0, _forEach.default)(fieldsToPreserve, function (fieldName) {
        newData.set(fieldName, _this8.data.get(fieldName));

        _this8._doneFields.set(fieldName, true);
      }); // eslint-disable-next-line lodash/prefer-lodash-method

      this.replaceData(newData);
    }
    /* Preferred over clear() in cases where form has non-nullable or pre-set values */

  }, {
    key: "resetToDefault",
    value: function resetToDefault() {
      this.replaceData(this._originalData);
    }
  }, {
    key: "replaceData",
    value: function replaceData(data) {
      // eslint-disable-next-line lodash/prefer-lodash-method
      this.data.clear();
      this.data.merge(data);
    }
  }, {
    key: "markStepDone",
    value: function markStepDone(stepKey) {
      var _this9 = this;

      if (!this.validationSteps[stepKey]) {
        throw new Error("".concat(stepKey, " validation step does not exist"));
      }

      (0, _forEach.default)(this.validationSteps[stepKey], function (field) {
        return _this9.markFieldDone(field);
      });
    }
  }, {
    key: "markFieldDone",
    value: function markFieldDone(fieldName) {
      this._doneFields.set(fieldName, true); // NOTE: this will result in a subform saying that a field that doesn't actually exist in that subform
      // has been touched because that field exists in the parent
      // This is okay if we assume that field names are unique across parents and subforms


      this._callFunctionOnSubForm("markFieldDone", fieldName);
    }
  }, {
    key: "validateStep",
    value: function validateStep(stepKey) {
      var _this10 = this;

      if (!this.validationSteps[stepKey]) {
        throw new Error("".concat(stepKey, " validation step does not exist"));
      }

      (0, _forEach.default)(this.validationSteps[stepKey], function (field) {
        return _this10.markFieldDone(field);
      });
    }
  }, {
    key: "allDone",
    value: function allDone() {
      var _this11 = this;

      // eslint-disable-next-line lodash/prefer-lodash-method
      this._validationComputeds.forEach(function (v, k) {
        return _this11.markFieldDone(k);
      });
    }
  }, {
    key: "save",
    value: function save(dispatcher, successCallback, validationErrorCallback) {
      var _this12 = this;

      this._serverErrors.clear();

      this.allDone(); // Some errors like loan account numbers do not trigger
      // until the server-side submit so this.hasErros is never set

      if ((0, _isFunction.default)(validationErrorCallback)) {
        this.validationErrorCallback = validationErrorCallback;
      }

      if (this.hasErrors) {
        (0, _isFunction.default)(validationErrorCallback) && validationErrorCallback();
        return;
      }

      var wrappedSuccessCallback = function wrappedSuccessCallback(err, res) {
        if (successCallback) {
          successCallback(err, res);
        }

        if (!(0, _isEmpty.default)(_this12.getOriginalData())) {
          _this12.setOriginalData();
        }
      };

      this.storageProvider.save(dispatcher, this.getData(), wrappedSuccessCallback);
    }
  }, {
    key: "delete",
    value: function _delete(dispatcher, callback) {
      this.storageProvider.delete(dispatcher, callback);
    }
  }, {
    key: "get",
    value: function get(fieldName) {
      return this.data.get(fieldName);
    } // only need to call this method if updating a form field from outside
    // the form's UI and we need to react to that change

  }, {
    key: "set",
    value: function set(fieldName, fieldValue) {
      // note that we're intentionally not touching fields here because this is
      // usually not called as a result of direct user action
      this.data.set(fieldName, fieldValue);
      this.emitter.emit("UPDATED_MODEL_VALUE", {
        fieldName: fieldName
      });
    }
  }, {
    key: "addSelectOption",
    value: function addSelectOption(selectViewModelName, optionViewModel) {
      if (this[selectViewModelName]) {
        this[selectViewModelName].options.push(optionViewModel);
      }
    }
  }, {
    key: "removeSelectOption",
    value: function removeSelectOption(selectViewModelName, matchingFunction) {
      if (this[selectViewModelName]) {
        this[selectViewModelName].options = (0, _filter.default)(this[selectViewModelName].options, function (option) {
          return !matchingFunction(option);
        });
      }
    }
  }, {
    key: "prevalidate",
    value: function prevalidate() {
      if (!(0, _isNull.default)(this.parent)) {
        this.parent.updateSubformIndexes();
      }
    }
  }, {
    key: "updateSubformIndexes",
    value: function updateSubformIndexes() {
      (0, _forEach.default)(_mobx2.observableMap.values(this.data), function (value) {
        if (FormModel._isSubformArray(value)) {
          (0, _forEach.default)(value, function (subform, index) {
            subform.index = index;
          });
        }
      });
    } // aligns with Baobab implementation of form error handling; should rewrite form responses
    // when everything is in mobx

  }, {
    key: "_processErrorsFromServer",
    value: function _processErrorsFromServer() {
      var _this13 = this;

      // clear cached form data on error fields
      this._errorFieldsFromServer.clear(); // eslint-disable-next-line lodash/prefer-lodash-method


      this._serverErrors.forEach(function (errorMessage, key) {
        // store the data we submitted for fields that had server errors
        if (!(0, _isUndefined.default)(_this13.data.get(key))) {
          _this13._errorFieldsFromServer.set(key, (0, _mobx.toJS)(_this13.data.get(key)));
        } // set server errors on subforms


        var splitKey = (0, _split.default)(key, ".");

        if (splitKey.length === 3) {
          var index = parseInt(splitKey[1], 10);
          var subformsName = splitKey[0];

          var subformErrors = _this13.get(subformsName)[index].errors;

          subformErrors.set(splitKey[2], errorMessage);
          (0, _forEach.default)(subformErrors, function (error, errorFieldName) {
            var subForm = _this13.get(subformsName);

            subForm[index]._serverErrors.set(errorFieldName, error);
          });
        }
      });
    }
  }, {
    key: "onFormError",
    value: function onFormError() {
      this._onFormError && this._onFormError();
    }
  }, {
    key: "setFormErrorHandler",
    value: function setFormErrorHandler(fn) {
      this._onFormError = fn;
    }
  }, {
    key: "clearErrors",
    value: function clearErrors(fieldNames) {
      var _this14 = this;

      if (!fieldNames || (0, _isEmpty.default)(fieldNames)) {
        this._doneFields.clear();
      } else {
        (0, _forEach.default)(fieldNames, function (fieldName) {
          _this14._doneFields.delete(fieldName);
        });
      }
    }
  }, {
    key: "_callFunctionOnSubForm",
    value: function _callFunctionOnSubForm(functionName) {
      for (var _len = arguments.length, functionArguments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        functionArguments[_key - 1] = arguments[_key];
      }

      (0, _forEach.default)(this.data, function (value) {
        if (FormModel._isSubform(value)) {
          if ((0, _isFunction.default)(value[functionName])) {
            value[functionName].apply(value, functionArguments);
          }
        } else if (FormModel._isSubformArray(value)) {
          (0, _forEach.default)(value, function (subform) {
            if ((0, _isFunction.default)(subform[functionName])) {
              subform[functionName].apply(subform, functionArguments);
            }
          });
        }
      });
    }
  }], [{
    key: "_isSubform",
    value: function _isSubform(value) {
      return value instanceof FormModel;
    }
  }, {
    key: "_isSubformArray",
    value: function _isSubformArray(value) {
      return !(0, _isUndefined.default)(value) && !(0, _isNull.default)(value) && (0, _isFunction.default)(value.slice) && (0, _isArray.default)(value.slice());
    }
  }]);

  return FormModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "data", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _mobx.observable.map();
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_originalData", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _mobx.observable.map();
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_validationComputeds", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _mobx.observable.map();
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_doneFields", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _mobx.observable.map();
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_serverErrors", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _mobx.observable.map();
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_errorFieldsFromServer", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _mobx.observable.map();
  }
}), _applyDecoratedDescriptor(_class.prototype, "serverErrors", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "serverErrors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errors", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "errors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "computedValidationErrors", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "computedValidationErrors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canSubmit", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "canSubmit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasChanges", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasChanges"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasErrors", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasErrors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allStepErrors", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "allStepErrors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isEmpty", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isEmpty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clear", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "clear"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetToDefault", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "resetToDefault"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "replaceData", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "replaceData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "markStepDone", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "markStepDone"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "markFieldDone", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "markFieldDone"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validateStep", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "validateStep"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allDone", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "allDone"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "save", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "save"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "delete", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "delete"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "set", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "set"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addSelectOption", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "addSelectOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeSelectOption", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeSelectOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "prevalidate", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "prevalidate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateSubformIndexes", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateSubformIndexes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_processErrorsFromServer", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "_processErrorsFromServer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onFormError", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onFormError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setFormErrorHandler", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setFormErrorHandler"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearErrors", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearErrors"), _class.prototype)), _class);
exports.default = FormModel;